import React from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";

import { Navigate, useLocation } from "react-router-dom";
import { ricordaDopoAccesso } from "../../utils/lastPageTracker";

const ProtectedRoute = ({ element }) => {
  const { user } = useSelector(state => state.auth);
  const location = useLocation();

  // Senza sessione si va all'accesso, non alla landing, e il link si ricorda:
  // dopo l'accesso (email, Google o Apple) si torna li' (STU-463). Prima chi
  // apriva il pulsante di una mail senza sessione finiva sulla pagina di
  // marketing e il link si perdeva.
  if (!user) {
    ricordaDopoAccesso(location.pathname, location.search);
    return <Navigate to="/signIn" replace={true} />;
  }

  return element;
};

// Protected Router Prop types
ProtectedRoute.propTypes = {
  element: PropTypes.element.isRequired,
};

export default ProtectedRoute;
